// import { Box, Grid, Paper, Typography } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import { callAPI, compressImageFile, getLocalValue, LoacalVariables, Method, transformCategoryData } from "../../commonFunctions/CommonFunctions";
// import http from "../../commonFunctions/httpClient";
// import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
// import WSButton from "../../Components/Button/WSButton";
// import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
// import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
// import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
// import WSSelectField from "../../Components/Select/WSSelect";
// import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
// import WSTextField, { CurrencyType, TextType } from "../../Components/TextBox/WSTextBox";
// import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
// import clientconfig from "../../Config/clientConfig.json";
// import config from "../../Config/config.json";
// import WSBackButton from "../../Components/BackButton/BackButton";
// import WSDateField from "../../Components/DateField/WSDateField";

// const VendorProductCreate: React.FC<any> = React.memo((props) => {
//     const { showMessage } = useSnackbar();
//     const { register, handleSubmit, control, setValue, watch, reset, getValues, formState: { errors } } = useForm();
//     const navigate = useNavigate();
//     const params = useParams();
//     const [selectedImage, setSelectedImage] = useState<any>();
//     const [imageUrl, setImageUrl] = useState<any>();
//     const [VendorData, setVendorData] = useState<any>(null);
//     const [loading, setLoading] = useState<boolean>(false);
//     const [loaded, setloaded] = useState<boolean>(true);
//     const id: any = params?.id;
//     const [selectedFile, setSelectedFile] = useState<File | null>(null);
//     const [imageList, setImageList] = useState<any>([]);
//     const [prevImageList, setPrevImageList] = useState<any>([]);
//     const [selectedDocuments, setSelectedDocuments] = useState<any>([]);
//     const [vendorId, setVendorId] = useState<string>("");
//     const [categoryOptions, setCategoryOptions] = useState<any>([]);

//     useEffect(() => () => {
//         reset();
//     }, []);

//     useEffect(() => {
//         breadCrumbsStore.updateBreadCrumbs([
//             { 'My Products': '/vendor-product/list' },
//             { [!id ? 'Add Product' : 'Update Product']: '/' },
//         ]);
//     }, [id]);

//     useEffect(() => {
//         const userId = getLocalValue(LoacalVariables.UserId);
//         setVendorId(userId || "");
//         console.log("user is is ", userId)
//     }, []);

//     const fetchCategories = async () => {
//         try {
//             const response: any = await http.get("pharmacy/Category");
//             setCategoryOptions(transformCategoryData(response));
//         } catch (error) {
//             console.error("Error fetching categories:", error);
//         }
//     };

//     useEffect(() => {
//         fetchCategories();
//     }, []);

// useEffect(() => {
//     async function getVendorProductById(id: any): Promise<void> {
//         if (!id) return;

//         try {
//             setloaded(false);
//             console.log('🔍 Loading product ID:', id);
//             const response: any = await http.get(`pharmacy/products/${id}`);
//             console.log('✅ FULL API RESPONSE:', response);

//             const productData = response;
//             if (productData && productData.id) {
//                 setVendorData(productData);

//                 const waitForOptions = () => {
//                     return new Promise<void>((resolve) => {
//                         const checkOptions = () => {
//                             const hasCategories = categoryOptions.length > 0;
//                             const hasProductTypes = clientconfig.mode?.staticOptionData?.length > 0;
//                             const hasStockStatus = clientconfig.stockStatus?.staticOptionData?.length > 0;

//                             if (hasCategories && hasProductTypes && hasStockStatus) {
//                                 resolve();
//                             } else {
//                                 setTimeout(checkOptions, 100);
//                             }
//                         };
//                         checkOptions();
//                     });
//                 };

//                 waitForOptions().then(() => {
//                     console.log('✅ ALL OPTIONS LOADED, filling form...');

//                     const productTypeOptions = clientconfig.mode.staticOptionData || [];
//                     const matchedProductType = productTypeOptions.find((opt: any) =>
//                         opt.value === productData.productType ||
//                         opt.label?.toLowerCase().includes(productData.productType?.toLowerCase())
//                     )?.value || productData.productType || "";
//                     setValue("ProductType", matchedProductType);

//                     const stockStatusOptions = clientconfig.stockStatus.staticOptionData || [];
//                     const matchedStockStatus = stockStatusOptions.find((opt: any) =>
//                         opt.value?.trim() === productData.stockStatus?.trim() ||
//                         opt.label?.trim().toLowerCase() === productData.stockStatus?.toLowerCase()
//                     )?.value || productData.stockStatus || "InStock";
//                     setValue("StockStatus", matchedStockStatus);

//                     const matchedCategory = categoryOptions.find((opt: any) => opt.value === productData.categoryId);
//                     setValue("CategoryId", matchedCategory ? productData.categoryId : "");

//                     // ✅ FIXED: Proper expiryDate format for WSDateField
//                     const expiryDate = productData.expiryDate;
//                     if (expiryDate) {
//                         const date = new Date(expiryDate);
//                         const formattedDate = date.toISOString().split('T')[0]; // "2026-01-06"
//                         setValue("ExpiryDate", [formattedDate]);
//                     }

//                     setValue("ProductName", productData.productName || "");
//                     setValue("BrandName", productData.brandName || "");
//                     setValue("ProductDescription", productData.productDescription || "");
//                     setValue("PackSize", productData.packSize || "");
//                     setValue("BatchNumber", productData.batchNumber || "");
//                     setValue("ManufacturingCompany", productData.manufacturingCompany || "");
//                     setValue("StockQuantity", productData.stockQuantity?.toString() || "0");
//                     setValue("CostPrice", productData.costPrice?.toString() || "0");
//                     setValue("MRP", productData.mrp?.toString() || "0");
//                     setValue("DiscountPercentage", productData.discountPercentage?.toString() || "0");
//                     setValue("PrescriptionRequired", productData.prescriptionRequired || false);

//                     console.log('✅ FORM FILLED COMPLETE');
//                 });

//                 if (productData.productImageUrl) {
//                     setImageUrl(`${config.imgUrl}${productData.productImageUrl}`);
//                     console.log('✅ Existing main image URL set');
//                 }

//                 if (productData.thumbnailUrls?.length > 0) {
//                     const imgList = productData.thumbnailUrls.map((url: string) => ({
//                         url: `${config.imgUrl}${url}`
//                     }));
//                     setImageList(imgList);
//                     setPrevImageList(imgList);
//                     setSelectedImage(imgList[0]?.url);
//                 }
//             }
//         } catch (error: any) {
//             console.error('💥 LOAD ERROR:', error);
//             showMessage("Error fetching product", "error");
//         } finally {
//             setloaded(true);
//         }
//     }

//     if (id) {
//         getVendorProductById(id);
//     }
// }, [id, setValue, categoryOptions, clientconfig]);

//     const handleCancelClick = () => {
//         navigate(`/vendor-product/list`);
//     };

//     const handleUploadChange = async (uploadedFile: any) => {
//         console.log('🔄 Main image upload triggered:', uploadedFile);
//         const file: any = uploadedFile;
//         try {
//             let newFile: any = await compressImageFile(uploadedFile);
//             setSelectedFile(newFile);
//             console.log('✅ New main image selected:', newFile.name);
//         } catch (error) {
//             console.error('❌ Image compression failed:', error);
//             showMessage("Error processing image", "error");
//         }
//     };

//     // ✅ FIXED: Complete setRequest with proper expiryDate formatting
//     const setRequest = async (data: any) => {
//         const formData = new FormData();

//         console.log('📋 Form data before processing:', data);
//         console.log('🖼️  Main image state:', { selectedFile: !!selectedFile, VendorData: !!VendorData?.productImageUrl });

//         // ✅ FIX: Convert expiryDate from ["2026-01-06"] to ISO datetime "2026-01-06T05:41:47.582Z"
//         let formattedExpiryDate = "";
//         if (data.ExpiryDate?.[0]) {
//             const date = new Date(data.ExpiryDate[0]);
//             if (!isNaN(date.getTime())) {
//                 formattedExpiryDate = date.toISOString(); // Backend expects: "2026-01-06T05:41:47.582Z"
//             }
//         }

//         const trimmedStockStatus = data.StockStatus?.trim() || "InStock";

//         formData.append("vendorId", vendorId);
//         formData.append("stockStatus", trimmedStockStatus);
//         formData.append("productName", data.ProductName || "");
//         formData.append("brandName", data.BrandName || "");
//         formData.append("productDescription", data.ProductDescription || "");
//         formData.append("productType", data.ProductType || "");
//         formData.append("packSize", data.PackSize || "");
//         formData.append("categoryId", data.CategoryId || "");
//         formData.append("batchNumber", data.BatchNumber || "");

//         // ✅ FIXED: Send proper ISO datetime format backend expects
//         formData.append("expiryDate", formattedExpiryDate);

//         formData.append("manufacturingCompany", data.ManufacturingCompany || "");
//         formData.append("stockQuantity", data.StockQuantity || "0");
//         formData.append("costPrice", data.CostPrice || "0");
//         formData.append("mrp", data.MRP || "0");
//         formData.append("discountPercentage", data.DiscountPercentage || "0");
//         formData.append("prescriptionRequired", data.PrescriptionRequired ? "true" : "false");
//         formData.append("isActive", "true");

//         if (selectedFile) {
//             formData.append("productImage", selectedFile);
//             console.log('✅ SENDING NEW productImage:', selectedFile.name, selectedFile.size);
//         }

//         if (selectedDocuments && selectedDocuments.length > 0) {
//             selectedDocuments.forEach((file: File) => {
//                 formData.append("thumbnails", file);
//             });
//             console.log(`✅ Added ${selectedDocuments.length} thumbnails`);
//         }

//         console.log('📤 FINAL FormData contents:');
//         console.log('📅 expiryDate:', formattedExpiryDate);
//         for (let [key, value] of formData.entries()) {
//             if (key === 'productImage' && value instanceof File) {
//                 console.log(`${key}: [File Object] ${value.name} (${value.size} bytes)`);
//             } else {
//                 console.log(key, typeof value === 'object' ? '[File Object]' : value);
//             }
//         }

//         return formData;
//     };

//     // ✅ FIXED: Enhanced error handling with full error details
//     const onSubmit = async (data: any) => {
//     console.log('🚀 SUBMIT triggered with:', { selectedFile: !!selectedFile });
//     console.log('📋 FULL FORM DATA:', data);

//     if (!id && !selectedFile) {
//         showMessage("Please upload a main product image", "error");
//         return;
//     }

//     // ✅ NEW: Retry logic for database errors
//     const maxRetries = 3;
//     let lastError = null;

//     for (let attempt = 1; attempt <= maxRetries; attempt++) {
//         try {
//             setLoading(true);
//             const request = await setRequest(data);

//             let response;
//             if (id && VendorData?.id) {
//                 console.log(`🔄 UPDATING product (attempt ${attempt}):`, VendorData.id);
//                 response = await callAPI(`pharmacy/products/${VendorData.id}`, Method.PUTFORMDATA, null, null, request);
//             } else {
//                 console.log(`➕ CREATING new product (attempt ${attempt})`);
//                 response = await callAPI("pharmacy/products", Method.POSTFORMDATA, null, null, request);
//             }

//             console.log("✅ FULL API RESPONSE:", response);

//             if (response?.status === true || response?.success) {
//                 showMessage(response.message || "Product saved successfully", "success");
//                 navigate(`/vendor-product/list`);
//                 return; // ✅ SUCCESS - exit retry loop
//             } else {
//                 lastError = response;
//                 console.log(`❌ Attempt ${attempt} failed:`, response?.message);
//             }
//         } catch (e: any) {
//             lastError = e;
//             console.error(`💥 Attempt ${attempt} ERROR:`, {
//                 status: e.response?.status,
//                 message: e.response?.data?.message,
//                 errors: e.response?.data?.errors,
//                 fullData: e.response?.data
//             });

//             // If not a database save error, don't retry
//             if (e.response?.status !== 500 || attempt === maxRetries) {
//                 throw e;
//             }

//             // Wait before retry (database might be locked)
//             await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
//         } finally {
//             setLoading(false);
//         }
//     }

//     // All retries failed
//     const finalError = lastError;
//     showMessage(
//         finalError?.response?.data?.message || 
//         "Database error. Please try again or contact support.", 
//         'error'
//     );
// };


//     const handleUploadFile = (file: any) => {
//         if (file && file.length > 0) {
//             setSelectedDocuments(file);
//             const previewList = file?.map((files: any) => ({
//                 files,
//                 url: URL.createObjectURL(files),
//             }));
//             const allList: any = [...prevImageList, ...previewList];
//             setImageList(allList);
//             setSelectedImage(previewList?.length > 0 && previewList[0]?.url);
//         }
//     };

//     const handleRemoveFile = (file: any) => {
//         if (file && file.length > 0) {
//             setSelectedDocuments(file);
//             const previewList = file?.map((files: any) => ({
//                 files,
//                 url: URL.createObjectURL(files),
//             }));
//             const allList: any = [...prevImageList, ...previewList];
//             setImageList(allList);
//             setSelectedImage(previewList?.length > 0 && previewList[0]?.url);
//         } else {
//             setSelectedImage(null);
//             setImageList(prevImageList?.length > 0 ? prevImageList : []);
//             setSelectedImage(prevImageList?.length > 0 ? prevImageList[0]?.url : null);
//         }
//     };

//     const handleImageClick = (image: any) => setSelectedImage(image.url);

//     return (
//         <>
//             <WSBackButton id="btnScheduleBack" url={"/vendor-product/list"} />

//             <form onSubmit={handleSubmit(onSubmit)}>
//                 <Grid container spacing={2} mt={2}>
//                     <Grid item xs={12} sm={6}>
//                         <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px" }}>
//                             <Grid container spacing={2} mt={0}>
//                                 <Grid item sm={12} xs={12}>
//                                     <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Basic Information</Typography>
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <WSTextField control={control} id="ProductName" name="ProductName" rules={{ required: true }} label="Product Name *" />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <WSTextField control={control} id="BrandName" name="BrandName" rules={{ required: true }} label="Brand Name *" />
//                                 </Grid>
//                                 <Grid item sm={6} xs={12}>
//                                     <WSSelectField rules={{ required: true }} control={control} name="ProductType" id="ProductType" 
//                                         label="Product Type *" options={clientconfig.mode.staticOptionData} />
//                                 </Grid>
//                                 <Grid item xs={12} sm={6}>
//                                     <WSTextField control={control} id="PackSize" name="PackSize" rules={{ required: true }} label="Pack Size *" />
//                                 </Grid>
//                                 <Grid item sm={6} xs={12}>
//                                     <WSSelectField rules={{ required: true }} control={control} name="CategoryId" id="CategoryId" 
//                                         label="Medical Category *" options={categoryOptions} />
//                                 </Grid>
//                                 <Grid item sm={12} xs={12}>
//                                     <WSTextAreaField control={control} id="ProductDescription" name="ProductDescription" 
//                                         rules={{ required: true }} label="Description *" />
//                                 </Grid>
//                             </Grid>
//                         </Paper>
//                     </Grid>

//                     <Grid item xs={12} sm={6}>
//                         <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px", minHeight: "100%" }}>
//                             <Grid container spacing={2} mt={0}>
//                                 <Grid item xs={12}>
//                                     <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Inventory & Pricing</Typography>
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <WSTextField control={control} id="BatchNumber" name="BatchNumber" rules={{ required: true }} label="Batch Number *" />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <WSDateField id="ExpiryDate" name="ExpiryDate" label="Expiry Date *" dateFormat="DD-MM-YYYY" 
//                                         control={control} isInGridFilter={false} defaultValue="" rules={{ required: true }} disabled={loading} />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <WSTextField control={control} id="ManufacturingCompany" name="ManufacturingCompany" rules={{ required: true }} label="Manufacturing Company *" />
//                                 </Grid>
//                                 <Grid item sm={6} xs={12}>
//                                     <WSTextField control={control} type={TextType.Currency} currency={CurrencyType.Rupee} id="CostPrice" name="CostPrice" rules={{ required: true }} label="Cost Price *" />
//                                 </Grid>
//                                 <Grid item sm={6} xs={12}>
//                                     <WSTextField control={control} type={TextType.Currency} currency={CurrencyType.Rupee} id="MRP" name="MRP" rules={{ required: true }} label="MRP *" />
//                                 </Grid>
//                                 <Grid item sm={6} xs={12}>
//                                     <WSTextField type={TextType.Number} control={control} id="StockQuantity" name="StockQuantity" rules={{ required: true }} label="Stock Quantity *" />
//                                 </Grid>
//                                 <Grid item sm={6} xs={12}>
//                                     <WSSelectField rules={{ required: true }} control={control} name="StockStatus" id="StockStatus" 
//                                         label="Stock Status *" options={clientconfig.stockStatus.staticOptionData} />
//                                 </Grid>
//                                 <Grid item sm={6} xs={12}>
//                                     <WSTextField type={TextType.Number} control={control} id="DiscountPercentage" name="DiscountPercentage" rules={{ required: true }} label="Discount Percentage *" />
//                                 </Grid>
//                                 <Grid item sm={6} xs={12}>
//                                     <WSSCheckBoxField 
//                                         isMobile={true} 
//                                         control={control} 
//                                         id="PrescriptionRequired" 
//                                         name="PrescriptionRequired" 
//                                         rules={{ required: true }}
//                                         label="Prescription Required" 
//                                         switchType="IOS" 
//                                     />
//                                 </Grid>
//                             </Grid>
//                         </Paper>
//                     </Grid>

//                     <Grid item xs={12}>
//                         <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px" }}>
//                             <Grid container spacing={2} mt={0}>
//                                 <Grid item xs={12}>
//                                     <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                                         Product Image
//                                         <span style={{ color: "#828584", fontSize: "0.8rem" }}>
//                                             {" "} (Recommended Size 640 x 640 px, JPG / PNG Formats)
//                                             {selectedFile && (
//                                                 <span style={{ color: "green", fontSize: "0.8rem", marginLeft: 10 }}>
//                                                     ✓ {selectedFile.name}
//                                                 </span>
//                                             )}
//                                             {imageUrl && !selectedFile && id && (
//                                                 <span style={{ color: "green", fontSize: "0.8rem", marginLeft: 10 }}>
//                                                     ✓ Current image loaded
//                                                 </span>
//                                             )}
//                                         </span>
//                                     </Typography>
//                                 </Grid>
//                                 <Grid item sm={4} xs={12}>
//                                     <WSImageUpload
//                                         control={control}
//                                         id="MainImage"
//                                         name="MainImage"
//                                         label="Product Image *"
//                                         rules={{ required: !id }}
//                                         onChange={handleUploadChange}
//                                         imgUrl={imageUrl}
//                                     />
//                                 </Grid>
//                             </Grid>
//                         </Paper>
//                     </Grid>

//                     <Grid item sm={12}>
//                         <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px" }}>
//                             <Grid container spacing={2} mt={0}>
//                                 <Grid item xs={12}>
//                                     <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                                         Image Gallery
//                                         <span style={{ color: "#828584", fontSize: "0.8rem" }}>
//                                             {" "} ( Recommended Size 640 x 640 px, JPG / PNG Formats )
//                                         </span>
//                                     </Typography>
//                                 </Grid>
//                                 <Grid item sm={6} style={{ overflow: "auto" }}>
//                                     <WSFileUpload
//                                         name="Thumbnails"
//                                         label="Gallery Images"
//                                         control={control}
//                                         rules={{ required: false }}
//                                         acceptFileTypes=".jpg,.jpeg,.png"
//                                         maxFileSizeMB={2}
//                                         id={"Thumbnails"}
//                                         image={true}
//                                         onChange={handleUploadFile}
//                                         onRemove={handleRemoveFile}
//                                         align="Start"
//                                         isToolTipImg={false}
//                                         multiple={true}
//                                     />
//                                 </Grid>
//                                 <Grid item sm={6} xs={12}>
//                                     <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
//                                         {selectedImage && (
//                                             <Box>
//                                                 <img
//                                                     src={selectedImage}
//                                                     alt="Selected Product"
//                                                     width="200"
//                                                     height="200"
//                                                     style={{ borderRadius: "8px", objectFit: "cover" }}
//                                                 />
//                                             </Box>
//                                         )}
//                                         <Box display="flex" flexDirection="row" gap="10px" flexWrap="wrap" justifyContent="center">
//                                             {imageList?.map((img: any, index: number) => (
//                                                 <Box
//                                                     key={index}
//                                                     border={img?.url === selectedImage ? "2px solid black" : "1px solid gray"}
//                                                     borderRadius="5px"
//                                                     overflow="hidden"
//                                                     onClick={() => handleImageClick(img)}
//                                                     sx={{
//                                                         cursor: "pointer",
//                                                         width: "70px",
//                                                         height: "70px",
//                                                     }}
//                                                 >
//                                                     <img
//                                                         src={img?.url}
//                                                         alt={`Product ${index}`}
//                                                         width="100%"
//                                                         height="100%"
//                                                         style={{ objectFit: "cover" }}
//                                                     />
//                                                 </Box>
//                                             ))}
//                                         </Box>
//                                     </Box>
//                                 </Grid>
//                             </Grid>
//                         </Paper>
//                     </Grid>

//                     <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
//                         <Grid item>
//                             <WSButton
//                                 id="cancel"
//                                 type="button"
//                                 label="Cancel"
//                                 size="medium"
//                                 onClick={handleCancelClick}
//                                 variant="outlined"
//                                 color="primary"
//                                 sx={{
//                                     borderRadius: 8,
//                                     width: "8rem",
//                                     border: "1px solid #098963",
//                                     color: "#098963",
//                                     backgroundColor: "#FFFFFF",
//                                 }}
//                             />
//                         </Grid>
//                         <Grid item>
//                             <WSButton
//                                 id="submit"
//                                 type="submit"
//                                 label="Save"
//                                 size="medium"
//                                 variant="outlined"
//                                 color="primary"
//                                 loading={loading}
//                                 sx={{
//                                     borderRadius: 8,
//                                     width: "8rem",
//                                     border: "1px solid #098963",
//                                     color: "#FFFFFF",
//                                     backgroundColor: "#098963",
//                                     '&:hover': {
//                                         backgroundColor: '#066e4f',
//                                     },
//                                 }}
//                             />
//                         </Grid>
//                     </Grid>
//                 </Grid>
//             </form>
//         </>
//     );
// });

// export default VendorProductCreate;




// import { Box, Grid, Paper, Typography } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   compressImageFile,
//   getLocalValue,
//   LoacalVariables,
//   transformCategoryData,
// } from "../../commonFunctions/CommonFunctions";
// import http from "../../commonFunctions/httpClient";
// import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
// import WSButton from "../../Components/Button/WSButton";
// import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
// import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
// import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
// import WSSelectField from "../../Components/Select/WSSelect";
// import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
// import WSTextField, {
//   CurrencyType,
//   TextType,
// } from "../../Components/TextBox/WSTextBox";
// import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
// import clientconfig from "../../Config/clientConfig.json";
// import config from "../../Config/config.json";
// import WSBackButton from "../../Components/BackButton/BackButton";
// import WSDateField from "../../Components/DateField/WSDateField";

// const VendorProductCreate: React.FC<any> = React.memo((props) => {
//   const { showMessage } = useSnackbar();

//   const {
//     control,
//     handleSubmit,
//     setValue,
//     reset,
//     getValues,
//     formState: { errors, isValid },
//   } = useForm({
//     mode: "onChange",
//   });

//   const navigate = useNavigate();
//   const params = useParams();
//   const [selectedImage, setSelectedImage] = useState<any>();
//   const [imageUrl, setImageUrl] = useState<any>();
//   const [VendorData, setVendorData] = useState<any>(null);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [loaded, setLoaded] = useState<boolean>(true);
//   const id: any = params?.id;

//   // files
//   const [mainImageFile, setMainImageFile] = useState<File | null>(null);
//   const [galleryFiles, setGalleryFiles] = useState<File[]>([]);
//   const [imageList, setImageList] = useState<any>([]);
//   const [prevImageList, setPrevImageList] = useState<any>([]);

//   const [vendorId, setVendorId] = useState<string>("");
//   const [categoryOptions, setCategoryOptions] = useState<any>([]);
//   const [isEditMode, setIsEditMode] = useState<boolean>(false);

//   useEffect(
//     () => () => {
//       reset();
//     },
//     [reset]
//   );

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "My Products": "/vendor-product/list" },
//       { [!id ? "Add Product" : "Update Product"]: "/" },
//     ]);
//     setIsEditMode(!!id);
//   }, [id]);

//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setVendorId(userId || "");
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       const response: any = await http.get("pharmacy/Category");
//       setCategoryOptions(transformCategoryData(response));
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//       showMessage("Error fetching categories", "error");
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     async function getVendorProductById(productId: any): Promise<void> {
//       if (!productId) return;

//       try {
//         setLoaded(false);
//         const response: any = await http.get(`pharmacy/products/${productId}`);
//         const productData = response;

//         if (productData && productData.id) {
//           setVendorData(productData);

//           setValue("ProductName", productData.productName || "");
//           setValue("BrandName", productData.brandName || "");
//           setValue("ProductDescription", productData.productDescription || "");
//           setValue("ProductType", productData.productType || "");
//           setValue("PackSize", productData.packSize || "");
//           setValue("CategoryId", productData.categoryId || "");
//           setValue("BatchNumber", productData.batchNumber || "");
//           setValue("ExpiryDate", productData.expiryDate || "");
//           setValue(
//             "ManufacturingCompany",
//             productData.manufacturingCompany || ""
//           );
//           setValue(
//             "StockQuantity",
//             productData.stockQuantity?.toString() || "0"
//           );

//           const stockStatus = productData.stockStatus;
//           if (stockStatus === 1 || stockStatus === "InStock") {
//             setValue("StockStatus", "InStock");
//           } else if (stockStatus === 2 || stockStatus === "OutOfStock") {
//             setValue("StockStatus", "OutOfStock");
//           } else if (stockStatus === 3 || stockStatus === "LimitedStock") {
//             setValue("StockStatus", "LimitedStock");
//           } else {
//             setValue("StockStatus", stockStatus || "InStock");
//           }

//           setValue("CostPrice", productData.costPrice?.toString() || "0");
//           setValue("MRP", productData.mrp?.toString() || "0");
//           setValue(
//             "DiscountPercentage",
//             productData.discountPercentage?.toString() || "0"
//           );
//           setValue(
//             "PrescriptionRequired",
//             !!productData.prescriptionRequired
//           );

//           if (productData.productImageUrl) {
//             setImageUrl(`${config.imgUrl}${productData.productImageUrl}`);
//           }
//           if (productData.thumbnailUrls?.length > 0) {
//             const imgList = productData.thumbnailUrls.map((url: string) => ({
//               url: `${config.imgUrl}${url}`,
//             }));
//             setImageList(imgList);
//             setPrevImageList(imgList);
//             setSelectedImage(imgList[0]?.url);
//           }
//         }
//       } catch (error: any) {
//         console.error("LOAD ERROR:", error);
//         showMessage("Error fetching product", "error");
//       } finally {
//         setLoaded(true);
//       }
//     }

//     if (id) {
//       getVendorProductById(id);
//     }
//   }, [id, setValue, showMessage, getValues]);

//   const handleCancelClick = () => {
//     navigate(`/vendor-product/list`);
//   };

//   // main image (single)
//   const handleUploadChange = async (uploadedFile: any) => {
//     const file: File | undefined = uploadedFile?.[0];
//     if (!file) {
//       setMainImageFile(null);
//       return;
//     }
//     try {
//       const compressed: any = await compressImageFile(uploadedFile);
//       // compressImageFile returns File or array – adapt if needed
//       const finalFile =
//         compressed instanceof File ? compressed : compressed?.[0] || file;
//       setMainImageFile(finalFile);
//     } catch (error) {
//       console.error(error);
//       showMessage("Error processing image", "error");
//     }
//   };

//   const normalizeDateToYMD = (value: any) => {
//     if (!value) return "";
//     const d = new Date(value);
//     if (isNaN(d.getTime())) return "";
//     const yyyy = d.getFullYear();
//     const mm = String(d.getMonth() + 1).padStart(2, "0");
//     const dd = String(d.getDate()).padStart(2, "0");
//     return `${yyyy}-${mm}-${dd}`;
//   };

//   const parseNumericString = (val: any, fallback = "0") => {
//     if (val === null || val === undefined) return fallback;
//     if (typeof val === "number") return val.toString();
//     const cleaned = String(val).replace(/[^\d.-]/g, "");
//     return cleaned || fallback;
//   };

//   // gallery upload (multiple)
//   const handleUploadFile = (file: any) => {
//     if (file && file.length > 0) {
//       const filesArray: File[] = Array.from(file);
//       setGalleryFiles((prev) => [...prev, ...filesArray]);

//       const previewList = filesArray.map((f: File) => ({
//         file: f,
//         url: URL.createObjectURL(f),
//       }));
//       const allList: any = [...prevImageList, ...previewList];
//       setImageList(allList);
//       setSelectedImage(previewList?.length > 0 && previewList[0].url);
//     }
//   };

//   const handleRemoveFile = (file: any) => {
//     if (file && file.length > 0) {
//       // WSFileUpload is giving remaining files here
//       const remainingFiles: File[] = Array.from(file);
//       setGalleryFiles(remainingFiles);

//       const previewList = remainingFiles.map((f: File) => ({
//         file: f,
//         url: URL.createObjectURL(f),
//       }));
//       const allList: any = [...prevImageList, ...previewList];
//       setImageList(allList);
//       setSelectedImage(
//         previewList?.length > 0 ? previewList[0].url : prevImageList[0]?.url
//       );
//     } else {
//       setGalleryFiles([]);
//       setSelectedImage(null);
//       setImageList(prevImageList?.length > 0 ? prevImageList : []);
//       setSelectedImage(
//         prevImageList?.length > 0 ? prevImageList[0].url : null
//       );
//     }
//   };

//   const handleImageClick = (image: any) => setSelectedImage(image.url);

//   const buttonLabel = isEditMode ? "Update" : "Save";

//   // build FormData (multipart) – similar to TechnicianDrawer
//   const buildFormData = (data: any) => {
//     const formData = new FormData();

//     // scalar fields – use API naming
//     formData.append("VendorId", vendorId || "");
//     formData.append("StockStatus", (data.StockStatus || "InStock").trim());
//     formData.append("ProductName", data.ProductName || "");
//     formData.append("BrandName", data.BrandName || "");
//     formData.append(
//       "ProductDescription",
//       data.ProductDescription || ""
//     );
//     formData.append("ProductType", data.ProductType || "");
//     formData.append("PackSize", data.PackSize || "");
//     formData.append("CategoryId", data.CategoryId || "");
//     formData.append("BatchNumber", data.BatchNumber || "");
//     formData.append("ExpiryDate", normalizeDateToYMD(data.ExpiryDate));
//     formData.append(
//       "ManufacturingCompany",
//       data.ManufacturingCompany || ""
//     );
//     formData.append(
//       "StockQuantity",
//       parseNumericString(data.StockQuantity)
//     );
//     formData.append("CostPrice", parseNumericString(data.CostPrice));
//     formData.append("MRP", parseNumericString(data.MRP));
//     formData.append(
//       "DiscountPercentage",
//       parseNumericString(data.DiscountPercentage, "0")
//     );
//     formData.append(
//       "PrescriptionRequired",
//       (
//         data.PrescriptionRequired === true ||
//         data.PrescriptionRequired === "true"
//       ).toString()
//     );
//     formData.append("IsActive", "true");

//     // main image
//     if (mainImageFile) {
//       formData.append("MainImage", mainImageFile);
//     }

//     // thumbnails array – depends on your API; this is a common pattern
//     galleryFiles.forEach((file, index) => {
//       formData.append("Thumbnails", file);
//       // or if API expects indexed: formData.append(`Thumbnails[${index}]`, file);
//     });

//     return formData;
//   };

//   const onSubmit = async (data: any) => {
//     console.log("✅ onSubmit called with data:", data);
//     try {
//       setLoading(true);
//       const formData = buildFormData(data);

//       let response: any;
//       if (id && VendorData?.id) {
//         // update – multipart
//         response = await http.putFormData(
//           `pharmacy/products/${VendorData.id}`,
//           formData
//         );
//       } else {
//         // create – multipart
//         response = await http.postFormData("pharmacy/products", formData);
//       }

//       console.log("✅ FULL API RESPONSE:", response);

//       const success =
//         response?.success === true ||
//         !!response?.data ||
//         response?.message?.toLowerCase?.().includes("success") ||
//         !response?.errors;

//       if (success) {
//         showMessage(
//           response?.message ||
//             (id
//               ? "Product updated successfully!"
//               : "Product created successfully!"),
//           "success"
//         );
//         navigate(`/vendor-product/list`);
//       } else {
//         showMessage(response?.message || "Failed to save product", "error");
//       }
//     } catch (e: any) {
//       console.error("💥 SUBMIT ERROR:", e);

//       if (e.response?.status === 422) {
//         const errors = e.response.data?.errors;
//         if (errors) {
//           const errorList = Object.entries(errors)
//             .map(
//               ([field, msgs]: any) =>
//                 `${field}: ${
//                   Array.isArray(msgs) ? msgs[0] : msgs
//                 }`
//             )
//             .join("\n");
//           showMessage(`Validation Errors:\n${errorList}`, "error");
//         }
//       } else {
//         showMessage(
//           e.response?.data?.message ||
//             e.response?.data?.title ||
//             e.message ||
//             "Failed to save product",
//           "error"
//         );
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/vendor-product/list"} />

//       <form onSubmit={handleSubmit(onSubmit)}>
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item sm={12} xs={12}>
//                   <Typography
//                     sx={{ fontSize: "1rem", fontWeight: "bold" }}
//                   >
//                     Basic Information
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     control={control}
//                     id="ProductName"
//                     name="ProductName"
//                     rules={{ required: true }}
//                     label="Product Name *"
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     control={control}
//                     id="BrandName"
//                     name="BrandName"
//                     rules={{ required: true }}
//                     label="Brand Name *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSelectField
//                     rules={{ required: true }}
//                     control={control}
//                     name="ProductType"
//                     id="ProductType"
//                     label="Product Type *"
//                     options={clientconfig.mode.staticOptionData}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSTextField
//                     control={control}
//                     id="PackSize"
//                     name="PackSize"
//                     rules={{ required: true }}
//                     label="Pack Size *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSelectField
//                     rules={{ required: true }}
//                     control={control}
//                     name="CategoryId"
//                     id="CategoryId"
//                     label="Medical Category *"
//                     options={categoryOptions}
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSTextAreaField
//                     control={control}
//                     id="ProductDescription"
//                     name="ProductDescription"
//                     rules={{ required: true }}
//                     label="Description *"
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//                 minHeight: "100%",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item xs={12}>
//                   <Typography
//                     sx={{ fontSize: "1rem", fontWeight: "bold" }}
//                   >
//                     Inventory & Pricing
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     control={control}
//                     id="BatchNumber"
//                     name="BatchNumber"
//                     rules={{ required: true }}
//                     label="Batch Number *"
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSDateField
//                     control={control}
//                     id="ExpiryDate"
//                     name="ExpiryDate"
//                     rules={{ required: true }}
//                     label="Expiry Date *"
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     control={control}
//                     id="ManufacturingCompany"
//                     name="ManufacturingCompany"
//                     rules={{ required: true }}
//                     label="Manufacturing Company *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSTextField
//                     control={control}
//                     type={TextType.Currency}
//                     currency={CurrencyType.Rupee}
//                     id="CostPrice"
//                     name="CostPrice"
//                     rules={{ required: true }}
//                     label="Cost Price *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSTextField
//                     control={control}
//                     type={TextType.Currency}
//                     currency={CurrencyType.Rupee}
//                     id="MRP"
//                     name="MRP"
//                     rules={{ required: true }}
//                     label="MRP *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSTextField
//                     type={TextType.Number}
//                     control={control}
//                     id="StockQuantity"
//                     name="StockQuantity"
//                     rules={{ required: true }}
//                     label="Stock Quantity *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSelectField
//                     rules={{ required: true }}
//                     control={control}
//                     name="StockStatus"
//                     id="StockStatus"
//                     label="Stock Status *"
//                     options={clientconfig.stockStatus.staticOptionData}
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSelectField
//                     rules={{ required: false }}
//                     control={control}
//                     name="DiscountPercentage"
//                     id="DiscountPercentage"
//                     options={clientconfig.taxPercentage.staticOptionData}
//                     label="Discount Percentage"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSCheckBoxField
//                     isMobile={true}
//                     control={control}
//                     id="PrescriptionRequired"
//                     name="PrescriptionRequired"
//                     rules={{ required: true }}
//                     label="Prescription Required"
//                     switchType="IOS"
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item xs={12}>
//                   <Typography
//                     sx={{ fontSize: "1rem", fontWeight: "bold" }}
//                   >
//                     Product Image
//                     <span
//                       style={{ color: "#828584", fontSize: "0.8rem" }}
//                     >
//                       {" "}
//                       ( Recommended Size 640 x 640 px, JPG / PNG Formats*
//                       )
//                     </span>
//                   </Typography>
//                 </Grid>
//                 <Grid item sm={4} xs={12}>
//                   <Grid
//                     container
//                     alignItems="center"
//                     spacing={2}
//                   >
//                     <Grid item>
//                       <WSImageUpload
//                         control={control}
//                         id="MainImage"
//                         name="MainImage"
//                         label="Product Image"
//                         rules={{ required: false }}
//                         onChange={handleUploadChange}
//                         imgUrl={imageUrl}
//                       />
//                     </Grid>
//                     <Grid item sx={{ mt: 2 }}>
//                       <Typography
//                         sx={{
//                           fontSize: "0.875rem",
//                           color: "gray",
//                         }}
//                       >
//                         {VendorData?.productName}
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item sm={12}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item xs={12}>
//                   <Typography
//                     sx={{ fontSize: "1rem", fontWeight: "bold" }}
//                   >
//                     Image Gallery
//                     <span
//                       style={{ color: "#828584", fontSize: "0.8rem" }}
//                     >
//                       {" "}
//                       ( Recommended Size 640 x 640 px, JPG / PNG Formats*
//                       )
//                     </span>
//                   </Typography>
//                 </Grid>
//                 <Grid
//                   item
//                   sm={6}
//                   style={{ overflow: "auto" }}
//                 >
//                   <WSFileUpload
//                     name="Thumbnails"
//                     label="Gallery Images"
//                     control={control}
//                     rules={{ required: false }}
//                     acceptFileTypes=".jpg,.jpeg,.png"
//                     maxFileSizeMB={2}
//                     id={"Thumbnails"}
//                     image={true}
//                     onChange={handleUploadFile}
//                     onRemove={handleRemoveFile}
//                     align="Start"
//                     isToolTipImg={false}
//                     multiple={true}
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <Box
//                     display="flex"
//                     flexDirection="column"
//                     alignItems="center"
//                     gap={2}
//                   >
//                     {selectedImage && (
//                       <Box>
//                         <img
//                           src={selectedImage}
//                           alt="Selected Product"
//                           width="200rem"
//                           height="200rem"
//                           style={{
//                             borderRadius: "8px",
//                             objectFit: "cover",
//                           }}
//                         />
//                       </Box>
//                     )}
//                     <Box
//                       display="flex"
//                       flexDirection="row"
//                       gap="10px"
//                       flexWrap="wrap"
//                       justifyContent="center"
//                     >
//                       {imageList?.map(
//                         (img: any, index: number) => (
//                           <Box
//                             key={index}
//                             border={
//                               img?.url === selectedImage
//                                 ? "2px solid black"
//                                 : "1px solid gray"
//                             }
//                             borderRadius="5px"
//                             overflow="hidden"
//                             onClick={() =>
//                               handleImageClick(img)
//                             }
//                             sx={{
//                               cursor: "pointer",
//                               width: "70px",
//                               height: "70px",
//                             }}
//                           >
//                             <img
//                               src={img?.url}
//                               alt={`Product ${index}`}
//                               width="100%"
//                               height="100%"
//                               style={{ objectFit: "cover" }}
//                             />
//                           </Box>
//                         )
//                       )}
//                     </Box>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid
//             container
//             justifyContent="flex-end"
//             spacing={2}
//             sx={{ mt: 2 }}
//           >
//             <Grid item>
//               <WSButton
//                 id="cancel"
//                 type="button"
//                 label="Cancel"
//                 size="medium"
//                 onClick={handleCancelClick}
//                 variant="outlined"
//                 color="primary"
//                 sx={{
//                   borderRadius: 8,
//                   width: "8rem",
//                   border: "1px solid #098963",
//                   color: "#098963",
//                   backgroundColor: "#FFFFFF",
//                 }}
//               />
//             </Grid>
//             <Grid item>
//               <WSButton
//                 id="submit"
//                 type="submit"
//                 label={buttonLabel}
//                 size="medium"
//                 variant="outlined"
//                 color="primary"
//                 loading={loading}
//                 disabled={!isValid || loading}
//                 sx={{
//                   borderRadius: 8,
//                   width: "8rem",
//                   border: "1px solid #098963",
//                   color: "#FFFFFF",
//                   backgroundColor: "#098963",
//                   "&:hover": {
//                     backgroundColor: "#066e4f",
//                   },
//                 }}
//               />
//             </Grid>
//           </Grid>
//         </Grid>
//       </form>
//     </>
//   );
// });

// export default VendorProductCreate;





// import { Box, Grid, Paper, Typography } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   compressImageFile,
//   getLocalValue,
//   LoacalVariables,
//   transformCategoryData,
// } from "../../commonFunctions/CommonFunctions";
// import http from "../../commonFunctions/httpClient";
// import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
// import WSButton from "../../Components/Button/WSButton";
// import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
// import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
// import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
// import WSSelectField from "../../Components/Select/WSSelect";
// import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
// import WSTextField, {
//   CurrencyType,
//   TextType,
// } from "../../Components/TextBox/WSTextBox";
// import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
// import clientconfig from "../../Config/clientConfig.json";
// import config from "../../Config/config.json";
// import WSBackButton from "../../Components/BackButton/BackButton";
// import WSDateField from "../../Components/DateField/WSDateField";

// const VendorProductCreate: React.FC<any> = React.memo((props) => {
//   const { showMessage } = useSnackbar();

//   const {
//     control,
//     handleSubmit,
//     setValue,
//     reset,
//     getValues,
//     formState: { errors, isValid },
//   } = useForm({
//     mode: "onChange",
//   });

//   const navigate = useNavigate();
//   const params = useParams();
//   const [selectedImage, setSelectedImage] = useState<any>();
//   const [imageUrl, setImageUrl] = useState<any>();
//   const [VendorData, setVendorData] = useState<any>(null);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [loaded, setLoaded] = useState<boolean>(true);
//   const id: any = params?.id;

//   // files
//   const [mainImageFile, setMainImageFile] = useState<File | null>(null);
//   const [galleryFiles, setGalleryFiles] = useState<File[]>([]);
//   const [imageList, setImageList] = useState<any>([]);
//   const [prevImageList, setPrevImageList] = useState<any>([]);

//   const [vendorId, setVendorId] = useState<string>("");
//   const [categoryOptions, setCategoryOptions] = useState<any>([]);
//   const [isEditMode, setIsEditMode] = useState<boolean>(false);

//   useEffect(
//     () => () => {
//       reset();
//     },
//     [reset]
//   );

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "My Products": "/vendor-product/list" },
//       { [!id ? "Add Product" : "Update Product"]: "/" },
//     ]);
//     setIsEditMode(!!id);
//   }, [id]);

//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setVendorId(userId || "");
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       const response: any = await http.get("pharmacy/Category");
//       setCategoryOptions(transformCategoryData(response));
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//       showMessage("Error fetching categories", "error");
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     async function getVendorProductById(productId: any): Promise<void> {
//       if (!productId) return;

//       try {
//         setLoaded(false);
//         const response: any = await http.get(`pharmacy/products/${productId}`);
//         const productData = response;

//         if (productData && productData.id) {
//           setVendorData(productData);

//           setValue("ProductName", productData.productName || "");
//           setValue("BrandName", productData.brandName || "");
//           setValue("ProductDescription", productData.productDescription || "");
//           setValue("ProductType", productData.productType || "");
//           setValue("PackSize", productData.packSize || "");
//           setValue("CategoryId", productData.categoryId || "");
//           setValue("BatchNumber", productData.batchNumber || "");
//           setValue("ExpiryDate", productData.expiryDate || "");
//           setValue(
//             "ManufacturingCompany",
//             productData.manufacturingCompany || ""
//           );
//           setValue(
//             "StockQuantity",
//             productData.stockQuantity?.toString() || "0"
//           );

//           const stockStatus = productData.stockStatus;
//           if (stockStatus === 1 || stockStatus === "InStock") {
//             setValue("StockStatus", "InStock");
//           } else if (stockStatus === 2 || stockStatus === "OutOfStock") {
//             setValue("StockStatus", "OutOfStock");
//           } else if (stockStatus === 3 || stockStatus === "LimitedStock") {
//             setValue("StockStatus", "LimitedStock");
//           } else {
//             setValue("StockStatus", stockStatus || "InStock");
//           }

//           setValue("CostPrice", productData.costPrice?.toString() || "0");
//           setValue("MRP", productData.mrp?.toString() || "0");
//           setValue(
//             "DiscountPercentage",
//             productData.discountPercentage?.toString() || "0"
//           );
//           setValue(
//             "PrescriptionRequired",
//             !!productData.prescriptionRequired
//           );

//           if (productData.productImageUrl) {
//             setImageUrl(`${config.imgUrl}${productData.productImageUrl}`);
//           }
//           if (productData.thumbnailUrls?.length > 0) {
//             const imgList = productData.thumbnailUrls.map((url: string) => ({
//               url: `${config.imgUrl}${url}`,
//             }));
//             setImageList(imgList);
//             setPrevImageList(imgList);
//             setSelectedImage(imgList[0]?.url);
//           }
//         }
//       } catch (error: any) {
//         console.error("LOAD ERROR:", error);
//         showMessage("Error fetching product", "error");
//       } finally {
//         setLoaded(true);
//       }
//     }

//     if (id) {
//       getVendorProductById(id);
//     }
//   }, [id, setValue, showMessage, getValues]);

//   const handleCancelClick = () => {
//     navigate(`/vendor-product/list`);
//   };

//   // main image (single)
//   const handleUploadChange = async (uploadedFile: any) => {
//     const file: File | undefined = uploadedFile?.[0];
//     if (!file) {
//       setMainImageFile(null);
//       return;
//     }
//     try {
//       const compressed: any = await compressImageFile(uploadedFile);
//       // compressImageFile returns File or array – adapt if needed
//       const finalFile =
//         compressed instanceof File ? compressed : compressed?.[0] || file;
//       setMainImageFile(finalFile);
//     } catch (error) {
//       console.error(error);
//       showMessage("Error processing image", "error");
//     }
//   };

//   const normalizeDateToYMD = (value: any) => {
//     if (!value) return "";
//     const d = new Date(value);
//     if (isNaN(d.getTime())) return "";
//     const yyyy = d.getFullYear();
//     const mm = String(d.getMonth() + 1).padStart(2, "0");
//     const dd = String(d.getDate()).padStart(2, "0");
//     return `${yyyy}-${mm}-${dd}`;
//   };

//   const parseNumericString = (val: any, fallback = "0") => {
//     if (val === null || val === undefined) return fallback;
//     if (typeof val === "number") return val.toString();
//     const cleaned = String(val).replace(/[^\d.-]/g, "");
//     return cleaned || fallback;
//   };

//   // gallery upload (multiple)
//   const handleUploadFile = (file: any) => {
//     if (file && file.length > 0) {
//       const filesArray: File[] = Array.from(file);
//       setGalleryFiles((prev) => [...prev, ...filesArray]);

//       const previewList = filesArray.map((f: File) => ({
//         file: f,
//         url: URL.createObjectURL(f),
//       }));
//       const allList: any = [...prevImageList, ...previewList];
//       setImageList(allList);
//       setSelectedImage(previewList?.length > 0 && previewList[0].url);
//     }
//   };

//   const handleRemoveFile = (file: any) => {
//     if (file && file.length > 0) {
//       // WSFileUpload is giving remaining files here
//       const remainingFiles: File[] = Array.from(file);
//       setGalleryFiles(remainingFiles);

//       const previewList = remainingFiles.map((f: File) => ({
//         file: f,
//         url: URL.createObjectURL(f),
//       }));
//       const allList: any = [...prevImageList, ...previewList];
//       setImageList(allList);
//       setSelectedImage(
//         previewList?.length > 0 ? previewList[0].url : prevImageList[0]?.url
//       );
//     } else {
//       setGalleryFiles([]);
//       setSelectedImage(null);
//       setImageList(prevImageList?.length > 0 ? prevImageList : []);
//       setSelectedImage(
//         prevImageList?.length > 0 ? prevImageList[0].url : null
//       );
//     }
//   };

//   const handleImageClick = (image: any) => setSelectedImage(image.url);

//   const buttonLabel = isEditMode ? "Update" : "Save";

//   // build FormData (multipart) – similar to TechnicianDrawer
//   const buildFormData = (data: any) => {
//     const formData = new FormData();

//     // scalar fields – use API naming
//     formData.append("VendorId", vendorId || "");
//     formData.append("StockStatus", (data.StockStatus || "InStock").trim());
//     formData.append("ProductName", data.ProductName || "");
//     formData.append("BrandName", data.BrandName || "");
//     formData.append(
//       "ProductDescription",
//       data.ProductDescription || ""
//     );
//     formData.append("ProductType", data.ProductType || "");
//     formData.append("PackSize", data.PackSize || "");
//     formData.append("CategoryId", data.CategoryId || "");
//     formData.append("BatchNumber", data.BatchNumber || "");
//     formData.append("ExpiryDate", normalizeDateToYMD(data.ExpiryDate));
//     formData.append(
//       "ManufacturingCompany",
//       data.ManufacturingCompany || ""
//     );
//     formData.append(
//       "StockQuantity",
//       parseNumericString(data.StockQuantity)
//     );
//     formData.append("CostPrice", parseNumericString(data.CostPrice));
//     formData.append("MRP", parseNumericString(data.MRP));
//     formData.append(
//       "DiscountPercentage",
//       parseNumericString(data.DiscountPercentage, "0")
//     );
//     formData.append(
//       "PrescriptionRequired",
//       (
//         data.PrescriptionRequired === true ||
//         data.PrescriptionRequired === "true"
//       ).toString()
//     );
//     formData.append("IsActive", "true");

//     // main image
//     if (mainImageFile) {
//       formData.append("MainImage", mainImageFile);
//     }

//     // thumbnails array – depends on your API; this is a common pattern
//     galleryFiles.forEach((file, index) => {
//       formData.append("Thumbnails", file);
//       // or if API expects indexed: formData.append(`Thumbnails[${index}]`, file);
//     });

//     return formData;
//   };

//   const onSubmit = async (data: any) => {
//     console.log("✅ onSubmit called with data:", data);
//     try {
//       setLoading(true);
//       const formData = buildFormData(data);

//       let response: any;
//       if (id && VendorData?.id) {
//         // update – multipart
//         response = await http.putFormData(
//           `pharmacy/products/${VendorData.id}`,
//           formData
//         );
//       } else {
//         // create – multipart
//         response = await http.postFormData("pharmacy/products", formData);
//       }

//       console.log("✅ FULL API RESPONSE:", response);

//       const success =
//         response?.success === true ||
//         !!response?.data ||
//         response?.message?.toLowerCase?.().includes("success") ||
//         !response?.errors;

//       if (success) {
//         showMessage(
//           response?.message ||
//             (id
//               ? "Product updated successfully!"
//               : "Product created successfully!"),
//           "success"
//         );
//         navigate(`/vendor-product/list`);
//       } else {
//         showMessage(response?.message || "Failed to save product", "error");
//       }
//     } catch (e: any) {
//       console.error("💥 SUBMIT ERROR:", e);

//       if (e.response?.status === 422) {
//         const errors = e.response.data?.errors;
//         if (errors) {
//           const errorList = Object.entries(errors)
//             .map(
//               ([field, msgs]: any) =>
//                 `${field}: ${
//                   Array.isArray(msgs) ? msgs[0] : msgs
//                 }`
//             )
//             .join("\n");
//           showMessage(`Validation Errors:\n${errorList}`, "error");
//         }
//       } else {
//         showMessage(
//           e.response?.data?.message ||
//             e.response?.data?.title ||
//             e.message ||
//             "Failed to save product",
//           "error"
//         );
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/vendor-product/list"} />

//       <form onSubmit={handleSubmit(onSubmit)}>
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item sm={12} xs={12}>
//                   <Typography
//                     sx={{ fontSize: "1rem", fontWeight: "bold" }}
//                   >
//                     Basic Information
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     control={control}
//                     id="ProductName"
//                     name="ProductName"
//                     rules={{ required: true }}
//                     label="Product Name *"
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     control={control}
//                     id="BrandName"
//                     name="BrandName"
//                     rules={{ required: true }}
//                     label="Brand Name *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSelectField
//                     rules={{ required: true }}
//                     control={control}
//                     name="ProductType"
//                     id="ProductType"
//                     label="Product Type *"
//                     options={clientconfig.mode.staticOptionData}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSTextField
//                     control={control}
//                     id="PackSize"
//                     name="PackSize"
//                     rules={{ required: true }}
//                     label="Pack Size *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSelectField
//                     rules={{ required: true }}
//                     control={control}
//                     name="CategoryId"
//                     id="CategoryId"
//                     label="Medical Category *"
//                     options={categoryOptions}
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSTextAreaField
//                     control={control}
//                     id="ProductDescription"
//                     name="ProductDescription"
//                     rules={{ required: true }}
//                     label="Description *"
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//                 minHeight: "100%",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item xs={12}>
//                   <Typography
//                     sx={{ fontSize: "1rem", fontWeight: "bold" }}
//                   >
//                     Inventory & Pricing
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     control={control}
//                     id="BatchNumber"
//                     name="BatchNumber"
//                     rules={{ required: true }}
//                     label="Batch Number *"
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSDateField
//                     control={control}
//                     id="ExpiryDate"
//                     name="ExpiryDate"
//                     rules={{ required: true }}
//                     label="Expiry Date *"
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     control={control}
//                     id="ManufacturingCompany"
//                     name="ManufacturingCompany"
//                     rules={{ required: true }}
//                     label="Manufacturing Company *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSTextField
//                     control={control}
//                     type={TextType.Currency}
//                     currency={CurrencyType.Rupee}
//                     id="CostPrice"
//                     name="CostPrice"
//                     rules={{ required: true }}
//                     label="Cost Price *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSTextField
//                     control={control}
//                     type={TextType.Currency}
//                     currency={CurrencyType.Rupee}
//                     id="MRP"
//                     name="MRP"
//                     rules={{ required: true }}
//                     label="MRP *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSTextField
//                     type={TextType.Number}
//                     control={control}
//                     id="StockQuantity"
//                     name="StockQuantity"
//                     rules={{ required: true }}
//                     label="Stock Quantity *"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSelectField
//                     rules={{ required: true }}
//                     control={control}
//                     name="StockStatus"
//                     id="StockStatus"
//                     label="Stock Status *"
//                     options={clientconfig.stockStatus.staticOptionData}
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSelectField
//                     rules={{ required: false }}
//                     control={control}
//                     name="DiscountPercentage"
//                     id="DiscountPercentage"
//                     options={clientconfig.taxPercentage.staticOptionData}
//                     label="Discount Percentage"
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <WSSCheckBoxField
//                     isMobile={true}
//                     control={control}
//                     id="PrescriptionRequired"
//                     name="PrescriptionRequired"
//                     rules={{ required: true }}
//                     label="Prescription Required"
//                     switchType="IOS"
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item xs={12}>
//                   <Typography
//                     sx={{ fontSize: "1rem", fontWeight: "bold" }}
//                   >
//                     Product Image
//                     <span
//                       style={{ color: "#828584", fontSize: "0.8rem" }}
//                     >
//                       {" "}
//                       ( Recommended Size 640 x 640 px, JPG / PNG Formats*
//                       )
//                     </span>
//                   </Typography>
//                 </Grid>
//                 <Grid item sm={4} xs={12}>
//                   <Grid
//                     container
//                     alignItems="center"
//                     spacing={2}
//                   >
//                     <Grid item>
//                       <WSImageUpload
//                         control={control}
//                         id="MainImage"
//                         name="MainImage"
//                         label="Product Image"
//                         rules={{ required: false }}
//                         onChange={handleUploadChange}
//                         imgUrl={imageUrl}
//                       />
//                     </Grid>
//                     <Grid item sx={{ mt: 2 }}>
//                       <Typography
//                         sx={{
//                           fontSize: "0.875rem",
//                           color: "gray",
//                         }}
//                       >
//                         {VendorData?.productName}
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item sm={12}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item xs={12}>
//                   <Typography
//                     sx={{ fontSize: "1rem", fontWeight: "bold" }}
//                   >
//                     Image Gallery
//                     <span
//                       style={{ color: "#828584", fontSize: "0.8rem" }}
//                     >
//                       {" "}
//                       ( Recommended Size 640 x 640 px, JPG / PNG Formats*
//                       )
//                     </span>
//                   </Typography>
//                 </Grid>
//                 <Grid
//                   item
//                   sm={6}
//                   style={{ overflow: "auto" }}
//                 >
//                   <WSFileUpload
//                     name="Thumbnails"
//                     label="Gallery Images"
//                     control={control}
//                     rules={{ required: false }}
//                     acceptFileTypes=".jpg,.jpeg,.png"
//                     maxFileSizeMB={2}
//                     id={"Thumbnails"}
//                     image={true}
//                     onChange={handleUploadFile}
//                     onRemove={handleRemoveFile}
//                     align="Start"
//                     isToolTipImg={false}
//                     multiple={true}
//                   />
//                 </Grid>
//                 <Grid item sm={6} xs={12}>
//                   <Box
//                     display="flex"
//                     flexDirection="column"
//                     alignItems="center"
//                     gap={2}
//                   >
//                     {selectedImage && (
//                       <Box>
//                         <img
//                           src={selectedImage}
//                           alt="Selected Product"
//                           width="200rem"
//                           height="200rem"
//                           style={{
//                             borderRadius: "8px",
//                             objectFit: "cover",
//                           }}
//                         />
//                       </Box>
//                     )}
//                     <Box
//                       display="flex"
//                       flexDirection="row"
//                       gap="10px"
//                       flexWrap="wrap"
//                       justifyContent="center"
//                     >
//                       {imageList?.map(
//                         (img: any, index: number) => (
//                           <Box
//                             key={index}
//                             border={
//                               img?.url === selectedImage
//                                 ? "2px solid black"
//                                 : "1px solid gray"
//                             }
//                             borderRadius="5px"
//                             overflow="hidden"
//                             onClick={() =>
//                               handleImageClick(img)
//                             }
//                             sx={{
//                               cursor: "pointer",
//                               width: "70px",
//                               height: "70px",
//                             }}
//                           >
//                             <img
//                               src={img?.url}
//                               alt={`Product ${index}`}
//                               width="100%"
//                               height="100%"
//                               style={{ objectFit: "cover" }}
//                             />
//                           </Box>
//                         )
//                       )}
//                     </Box>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid
//             container
//             justifyContent="flex-end"
//             spacing={2}
//             sx={{ mt: 2 }}
//           >
//             <Grid item>
//               <WSButton
//                 id="cancel"
//                 type="button"
//                 label="Cancel"
//                 size="medium"
//                 onClick={handleCancelClick}
//                 variant="outlined"
//                 color="primary"
//                 sx={{
//                   borderRadius: 8,
//                   width: "8rem",
//                   border: "1px solid #098963",
//                   color: "#098963",
//                   backgroundColor: "#FFFFFF",
//                 }}
//               />
//             </Grid>
//             <Grid item>
//               <WSButton
//                 id="submit"
//                 type="submit"
//                 label={buttonLabel}
//                 size="medium"
//                 variant="outlined"
//                 color="primary"
//                 loading={loading}
//                 disabled={!isValid || loading}
//                 sx={{
//                   borderRadius: 8,
//                   width: "8rem",
//                   border: "1px solid #098963",
//                   color: "#FFFFFF",
//                   backgroundColor: "#098963",
//                   "&:hover": {
//                     backgroundColor: "#066e4f",
//                   },
//                 }}
//               />
//             </Grid>
//           </Grid>
//         </Grid>
//       </form>
//     </>
//   );
// });

// export default VendorProductCreate;




import { Box, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  buildImageUrl,
  compressImageFile,
  dateFormat,
  getLocalValue,
  LoacalVariables,
} from "../../commonFunctions/CommonFunctions";
import http from "../../commonFunctions/httpClient";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import WSButton from "../../Components/Button/WSButton";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, {
  CurrencyType,
  TextType,
} from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import config from "../../Config/config.json";
import WSBackButton from "../../Components/BackButton/BackButton";
import WSDateField from "../../Components/DateField/WSDateField";

// quantity at or below this is marked "LimitedStock" (matches VendorProductList's "Low Stock")
const LOW_STOCK_THRESHOLD = 5;

const VendorProductCreate: React.FC<any> = React.memo((props) => {
  const { showMessage } = useSnackbar();

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  });

  const navigate = useNavigate();
  const params = useParams();
  const [selectedImage, setSelectedImage] = useState<any>();
  const [imageUrl, setImageUrl] = useState<any>();
  const [VendorData, setVendorData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(true);
  const id: any = params?.id;

  // files
  const [mainImageFile, setMainImageFile] = useState<File | null>(null);
  const [galleryFiles, setGalleryFiles] = useState<File[]>([]);
  const [imageList, setImageList] = useState<any>([]);
  const [prevImageList, setPrevImageList] = useState<any>([]);

  const [vendorId, setVendorId] = useState<string>("");
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  useEffect(
    () => () => {
      reset();
    },
    [reset]
  );

  useEffect(() => {
    breadCrumbsStore.updateBreadCrumbs([
      { "My Products": "/vendor-product/list" },
      { [!id ? "Add Product" : "Update Product"]: "/" },
    ]);
    setIsEditMode(!!id);
  }, [id]);

  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setVendorId(userId || "");
  }, []);

  useEffect(() => {
    async function getVendorProductById(productId: any): Promise<void> {
      if (!productId) return;

      try {
        setLoaded(false);
        const response: any = await http.get(`pharmacy/products/${productId}`);
        const productData = response;
        console.log("the response is ", response)

        if (productData && productData.id) {
          setVendorData(productData);

          setValue("ProductName", productData.productName || "");
          setValue("BrandName", productData.brandName || "");
          setValue("ProductDescription", productData.productDescription || "");
          setValue("ProductType", productData.productType || "");
          setValue("PackSize", productData.packSize || "");
          setValue("CategoryId", productData.categoryId || "");
          setValue("BatchNumber", productData.batchNumber || "");
          // setValue("ExpiryDate", productData.expiryDate || "");
          setValue('ExpiryDate', dateFormat(productData.expiryDate, 'DD-MM-YYYY HH:mm:ss'))
          setValue(
            "ManufacturingCompany",
            productData.manufacturingCompany || ""
          );
          setValue(
            "StockQuantity",
            productData.stockQuantity?.toString() || "0"
          );


          setValue("CostPrice", productData.costPrice?.toString() || "0");
          setValue("MRP", productData.mrp?.toString() || "0");
          setValue(
            "DiscountPercentage",
            productData.discountPercentage?.toString() || "0"
          );
          setValue(
            "PrescriptionRequired",
            !!productData.prescriptionRequired
          );

          // Same image addresses as the product details page (paths come as UploadedImages/...)
          if (productData.productImageUrl) {
            setImageUrl(buildImageUrl(productData.productImageUrl, config.imgUrl));
          }
          if (productData.thumbnailUrls?.length > 0) {
            const imgList = productData.thumbnailUrls.map((url: string) => ({
              url: buildImageUrl(url, config.imgUrl),
            }));
            setImageList(imgList);
            setPrevImageList(imgList);
            setSelectedImage(imgList[0]?.url);
          }
        }
      } catch (error: any) {
        console.error("LOAD ERROR:", error);
        showMessage("Error fetching product", "error");
      } finally {
        setLoaded(true);
      }
    }

    if (id) {
      getVendorProductById(id);
    }
  }, [id, setValue, showMessage, getValues]);

  const handleCancelClick = () => {
    navigate(`/vendor-product/list`);
  };


  // main image (single)
  const handleUploadChange = async (uploadedFile: any) => {
    const file: File | undefined = uploadedFile?.[0];
    if (!file) {
      setMainImageFile(null);
      return;
    }
    try {
      const compressed: any = await compressImageFile(uploadedFile);
      // compressImageFile returns File or array – adapt if needed
      const finalFile =
        compressed instanceof File ? compressed : compressed?.[0] || file;
      setMainImageFile(finalFile);
    } catch (error) {
      console.error(error);
      showMessage("Error processing image", "error");
    }
  };

  const normalizeDateToYMD = (value: any) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const parseNumericString = (val: any, fallback = "0") => {
    if (val === null || val === undefined) return fallback;
    if (typeof val === "number") return val.toString();
    const cleaned = String(val).replace(/[^\d.-]/g, "");
    return cleaned || fallback;
  };

  // stock status is derived from quantity instead of being picked manually
  const getStockStatus = (quantity: any) => {
    const qty = Number(parseNumericString(quantity));
    if (!qty || qty <= 0) return "OutOfStock";
    if (qty <= LOW_STOCK_THRESHOLD) return "LimitedStock";
    return "InStock";
  };

  // gallery upload (multiple)
  const handleUploadFile = (file: any) => {
    if (file && file.length > 0) {
      const filesArray: File[] = Array.from(file);
      setGalleryFiles((prev) => [...prev, ...filesArray]);

      const previewList = filesArray.map((f: File) => ({
        file: f,
        url: URL.createObjectURL(f),
      }));
      const allList: any = [...prevImageList, ...previewList];
      setImageList(allList);
      setSelectedImage(previewList?.length > 0 && previewList[0].url);
    }
  };

  const handleRemoveFile = (file: any) => {
    if (file && file.length > 0) {
      // WSFileUpload is giving remaining files here
      const remainingFiles: File[] = Array.from(file);
      setGalleryFiles(remainingFiles);

      const previewList = remainingFiles.map((f: File) => ({
        file: f,
        url: URL.createObjectURL(f),
      }));
      const allList: any = [...prevImageList, ...previewList];
      setImageList(allList);
      setSelectedImage(
        previewList?.length > 0 ? previewList[0].url : prevImageList[0]?.url
      );
    } else {
      setGalleryFiles([]);
      setSelectedImage(null);
      setImageList(prevImageList?.length > 0 ? prevImageList : []);
      setSelectedImage(
        prevImageList?.length > 0 ? prevImageList[0].url : null
      );
    }
  };

  const handleImageClick = (image: any) => setSelectedImage(image.url);

  const buttonLabel = isEditMode ? "Update" : "Save";

  // build FormData (multipart) – similar to TechnicianDrawer
  const buildFormData = (data: any) => {
    const formData = new FormData();

    // scalar fields – use API naming
    formData.append("VendorId", vendorId || "");
    formData.append("StockStatus", getStockStatus(data.StockQuantity));
    formData.append("ProductName", data.ProductName || "");
    formData.append("BrandName", data.BrandName || "");
    formData.append(
      "ProductDescription",
      data.ProductDescription || ""
    );
    formData.append("ProductType", data.ProductType || "");
    formData.append("PackSize", data.PackSize || "");
    formData.append("CategoryId", data.CategoryId || "");
    formData.append("BatchNumber", data.BatchNumber || "");
    formData.append("ExpiryDate", normalizeDateToYMD(data.ExpiryDate));
    formData.append(
      "ManufacturingCompany",
      data.ManufacturingCompany || ""
    );
    formData.append(
      "StockQuantity",
      parseNumericString(data.StockQuantity)
    );
    formData.append("CostPrice", parseNumericString(data.CostPrice));
    formData.append("MRP", parseNumericString(data.MRP));
    formData.append(
      "DiscountPercentage",
      parseNumericString(data.DiscountPercentage, "0")
    );
    formData.append(
      "PrescriptionRequired",
      (
        data.PrescriptionRequired === true ||
        data.PrescriptionRequired === "true"
      ).toString()
    );
    formData.append("IsActive", "true");

    // main image
    if (mainImageFile) {
      formData.append("MainImage", mainImageFile);
    }

    // thumbnails array – depends on your API; this is a common pattern
    galleryFiles.forEach((file, index) => {
      formData.append("Thumbnails", file);
      // or if API expects indexed: formData.append(`Thumbnails[${index}]`, file);
    });

    return formData;
  };

  const onSubmit = async (data: any) => {
    console.log("✅ onSubmit called with data:", data);
    try {
      setLoading(true);
      const formData = buildFormData(data);

      let response: any;
      if (id && VendorData?.id) {
        // update – multipart
        response = await http.putFormData(
          `pharmacy/products/${VendorData.id}`,
          formData
        );
      } else {
        // create – multipart
        response = await http.postFormData("pharmacy/products", formData);
      }

      console.log("✅ FULL API RESPONSE:", response);

      const success =
        response?.success === true ||
        !!response?.data ||
        response?.message?.toLowerCase?.().includes("success") ||
        !response?.errors;

      if (success) {
        showMessage(
          response?.message ||
          (id
            ? "Product updated successfully!"
            : "Product created successfully!"),
          "success"
        );
        navigate(`/vendor-product/list`);
      } else {
        showMessage(response?.message || "Failed to save product", "error");
      }
    } catch (e: any) {
      console.error("💥 SUBMIT ERROR:", e);

      if (e.response?.status === 422) {
        const errors = e.response.data?.errors;
        if (errors) {
          const errorList = Object.entries(errors)
            .map(
              ([field, msgs]: any) =>
                `${field}: ${Array.isArray(msgs) ? msgs[0] : msgs
                }`
            )
            .join("\n");
          showMessage(`Validation Errors:\n${errorList}`, "error");
        }
      } else {
        showMessage(
          e.response?.data?.message ||
          e.response?.data?.title ||
          e.message ||
          "Failed to save product",
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <WSBackButton id="btnScheduleBack" url={"/vendor-product/list"} />

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography
                    sx={{ fontSize: "1rem", fontWeight: "bold" }}
                  >
                    Basic Information
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    control={control}
                    id="ProductName"
                    name="ProductName"
                    rules={{ required: true }}
                    label="Product Name *"
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    control={control}
                    id="BrandName"
                    name="BrandName"
                    rules={{ required: true }}
                    label="Brand Name *"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    control={control}
                    id="PackSize"
                    name="PackSize"
                    rules={{ required: true }}
                    label="Pack Size *"
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextAreaField
                    control={control}
                    id="ProductDescription"
                    name="ProductDescription"
                    rules={{ required: true }}
                    label="Description *"
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
                minHeight: "100%",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12}>
                  <Typography
                    sx={{ fontSize: "1rem", fontWeight: "bold" }}
                  >
                    Inventory & Pricing
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSDateField
                    control={control}
                    id="ExpiryDate"
                    name="ExpiryDate"
                    rules={{ required: true }}
                    label="Expiry Date *"
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                    id="MRP"
                    name="MRP"
                    rules={{ required: true }}
                    label="MRP *"
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    type={TextType.Number}
                    control={control}
                    id="StockQuantity"
                    name="StockQuantity"
                    rules={{ required: true }}
                    label="Stock Quantity *"
                  />
                </Grid>
                {/* <Grid item sm={6} xs={12}>
                  <WSSelectField
                    rules={{ required: false }}
                    control={control}
                    name="DiscountPercentage"
                    id="DiscountPercentage"
                    options={clientconfig.taxPercentage.staticOptionData}
                    label="Discount Percentage"
                  />
                </Grid> */}

                <Grid item xs={12} sm={6}>
                  <WSTextField
                    control={control}
                    id="DiscountPercentage"
                    name="DiscountPercentage"
                    rules={{ required: false }}
                    label="DiscountPercentage"
                  />
                </Grid>

                <Grid item xs={12}>
                  {/* optional: "off" is a valid answer (over-the-counter product) */}
                  <WSSCheckBoxField
                    isMobile={true}
                    control={control}
                    id="PrescriptionRequired"
                    name="PrescriptionRequired"
                    rules={{ required: false }}
                    label="Prescription Required"
                    switchType="IOS"
                  />
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mt: 0.5 }}
                  >
                    Turn on for prescription-only medicines (Rx). Customers
                    must upload a valid doctor's prescription before they can
                    order this product. Leave off for over-the-counter items.
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12}>
                  <Typography
                    sx={{ fontSize: "1rem", fontWeight: "bold" }}
                  >
                    Product Image
                    <span
                      style={{ color: "#828584", fontSize: "0.8rem" }}
                    >
                      {" "}
                      ( Recommended Size 640 x 640 px, JPG / PNG Formats*
                      )
                    </span>
                  </Typography>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Grid
                    container
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item>
                      <WSImageUpload
                        control={control}
                        id="MainImage"
                        name="MainImage"
                        label="Product Image"
                        rules={{ required: false }}
                        onChange={handleUploadChange}
                        imgUrl={imageUrl}
                      />
                    </Grid>
                    <Grid item sx={{ mt: 2 }}>
                      <Typography
                        sx={{
                          fontSize: "0.875rem",
                          color: "gray",
                        }}
                      >
                        {VendorData?.productName}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item sm={12}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12}>
                  <Typography
                    sx={{ fontSize: "1rem", fontWeight: "bold" }}
                  >
                    Image Gallery
                    <span
                      style={{ color: "#828584", fontSize: "0.8rem" }}
                    >
                      {" "}
                      ( Recommended Size 640 x 640 px, JPG / PNG Formats*
                      )
                    </span>
                  </Typography>
                </Grid>
                <Grid
                  item
                  sm={6}
                  style={{ overflow: "auto" }}
                >
                  <WSFileUpload
                    name="Thumbnails"
                    label="Gallery Images"
                    control={control}
                    rules={{ required: false }}
                    acceptFileTypes=".jpg,.jpeg,.png"
                    maxFileSizeMB={2}
                    id={"Thumbnails"}
                    image={true}
                    onChange={handleUploadFile}
                    onRemove={handleRemoveFile}
                    align="Start"
                    isToolTipImg={false}
                    multiple={true}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                  >
                    {selectedImage && (
                      <Box>
                        <img
                          src={selectedImage}
                          alt="Selected Product"
                          width="200rem"
                          height="200rem"
                          style={{
                            borderRadius: "8px",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                    )}
                    <Box
                      display="flex"
                      flexDirection="row"
                      gap="10px"
                      flexWrap="wrap"
                      justifyContent="center"
                    >
                      {imageList?.map(
                        (img: any, index: number) => (
                          <Box
                            key={index}
                            border={
                              img?.url === selectedImage
                                ? "2px solid black"
                                : "1px solid gray"
                            }
                            borderRadius="5px"
                            overflow="hidden"
                            onClick={() =>
                              handleImageClick(img)
                            }
                            sx={{
                              cursor: "pointer",
                              width: "70px",
                              height: "70px",
                            }}
                          >
                            <img
                              src={img?.url}
                              alt={`Product ${index}`}
                              width="100%"
                              height="100%"
                              style={{ objectFit: "cover" }}
                            />
                          </Box>
                        )
                      )}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid
            container
            justifyContent="flex-end"
            spacing={2}
            sx={{ mt: 2 }}
          >
            <Grid item>
              <WSButton
                id="cancel"
                type="button"
                label="Cancel"
                size="medium"
                onClick={handleCancelClick}
                variant="outlined"
                color="primary"
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#098963",
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Grid>
            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label={buttonLabel}
                size="medium"
                variant="outlined"
                color="primary"
                loading={loading}
                disabled={!isValid || loading}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
});

export default VendorProductCreate;
